import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { ProductoTroncalProductoAgrupado } from '../_models/producto-troncal-producto-agrupado';

@Injectable({
  providedIn: 'root'
})
export class ProductoTroncalProductoAgrupadoService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/productosTroncalProductosAgrupados';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as ProductoTroncalProductoAgrupado[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as ProductoTroncalProductoAgrupado[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as ProductoTroncalProductoAgrupado ) );
  }

  listarPorProductoTroncal( idProductoTroncal: string ) {
    return this.httClient.get( this.rutServicio + '/productoTroncal/' + idProductoTroncal ).pipe( map( res => res as ProductoTroncalProductoAgrupado[] ) );
  }

  crear( regCrear: ProductoTroncalProductoAgrupado ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as ProductoTroncalProductoAgrupado ) );
  }

  actualizar( regActualizar: ProductoTroncalProductoAgrupado ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as ProductoTroncalProductoAgrupado ) );
  }

  crearActualizarLote( regs: ProductoTroncalProductoAgrupado[] ) {
    const usuario = this.autServicio.obtenerIdUsuarioLogueado();
    regs.forEach( r => r.auditoriaUsuario = usuario );
    return this.httClient.post( this.rutServicio + '/bulk', regs ).pipe( map( res => res as ProductoTroncalProductoAgrupado[] ) );
  }

}
